import {Injectable, inject} from "@angular/core";
import {CanActivate, Router} from "@angular/router";

@Injectable()
export class WaitingGuardService implements CanActivate {
    private router = inject(Router);


  canActivate(): boolean {
    // If the previous URL was blank, then the user is directly accessing this page
    if (this.router.url === '/') {
      this.router.navigate(['auth', 'login']); // Navigate away to some other page
      return false;
    }
    return true;
  }

}
